module.exports = __webpack_public_path__ + "static/img/headImg.3cf3170e.jpg";